export enum FeatureFlag {
	FeatureFlagForTesting = 'feature-flag-for-testing', // A feature flag used for testing purposes
	EnableProductLedGrowth = 'enable_product_led_growth', // Enable PLG banners and modal popups
	EnableSolutionUpgrades = 'enable-solution-upgrades', // Enable solution upgrades
	EnableSolutionDelete = 'enable-solution-delete', // Enables delete button for solutions
	EnableCatalogFilterSolutions = 'catalog_filter_solutions', // Enables filtering of individual solutions
	EnableBetaModeTaxPrepSolution = 'enable_beta_mode_tax_prep_solution', // Enables beta mode for the tax prep solution
	EnableBetaModeLegalSolution = 'enable_beta_mode_legal_solution', // Enables beta mode for the legal solution
	EnableBetaModeClientBillingSolution = 'enable_beta_mode_client_billing_solution', // Enables beta mode for the client billing solution
	EnableRetainData = 'enable_solution_retain_data',
	EnableBetaModeWorkManagementTemplate = 'enable_beta_mode_work_mgmt_template', // Enables beta mode for the work management template
	HideIntegrationsEU = 'hide_integrations_eu', // Hides integrations in the EU region
}
